import { render } from "./MetaForm.vue?vue&type=template&id=669024c4&scoped=true"
import script from "./MetaForm.vue?vue&type=script&lang=js"
export * from "./MetaForm.vue?vue&type=script&lang=js"

import "./MetaForm.vue?vue&type=style&index=0&id=669024c4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-669024c4"

export default script